import * as React from 'react';
import { loadImageFromS3 } from '../../../helpers/fileFunctions';
import { IMAGE_PLACEHOLDER } from '../../../constants/standard';
import './Image.scss';
export default function Image({ src, maxWidth, maxHeight, alt, bucket, fallback }) {
    const [image, setImage] = React.useState('');
    const [fallbackClass, setFallbackClass] = React.useState(false);
    React.useEffect(() => {
        if (src && !bucket) {
            // setImage(`https://${env}/public/${fileUploaded.key}`)
            // setImage(`https://test.trurisk.io/public/${src}`);
            setImage(src);
            // loadImageFromS3(src, bucket, fallback || IMAGE_PLACEHOLDER).then(setImage);
            setFallbackClass(false);
        }
        else if (src && bucket) {
            loadImageFromS3(src, bucket, fallback || IMAGE_PLACEHOLDER).then(setImage);
            setFallbackClass(false);
        }
        else {
            setImage(fallback || IMAGE_PLACEHOLDER);
            setFallbackClass(true);
        }
    }, [src, bucket, fallback]);
    const onError = () => {
        setImage(fallback || IMAGE_PLACEHOLDER);
        setFallbackClass(true);
    };
    return (React.createElement("div", { className: `image-container ${fallbackClass ? 'image-fallback' : ''}` }, image ? React.createElement("img", { onError: onError, alt: alt || 'imagealt', style: { maxHeight, maxWidth }, src: image }) : ''));
}
